import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.function.name.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import UserHistory from 'screens/userHistory';
import InlineStatsPanel from '.';
import { useFetchPopularAssetsInFolderOrPlaylist } from 'actions/assets';
function PopularAssetInFolderOrPlaylistStats(_ref) {
  var playlistId = _ref.playlistId,
    parentId = _ref.parentId,
    title = _ref.title,
    name = _ref.name,
    _ref$isPanelLayout = _ref.isPanelLayout,
    isPanelLayout = _ref$isPanelLayout === void 0 ? false : _ref$isPanelLayout;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasModal = _useState2[0],
    setHasModal = _useState2[1];
  var _useFetchPopularAsset = useFetchPopularAssetsInFolderOrPlaylist({
      playlistId: playlistId,
      parentId: parentId
    }),
    data = _useFetchPopularAsset.data,
    isLoading = _useFetchPopularAsset.isLoading,
    isError = _useFetchPopularAsset.isError;
  if (!data) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InlineStatsPanel, {
    isPanelLayout: isPanelLayout,
    title: title,
    data: data,
    onClick: function onClick() {
      return setHasModal(true);
    },
    isLoading: isLoading,
    isError: isError
  }), hasModal && /*#__PURE__*/React.createElement(UserHistory, {
    title: t('analytics_popular_asset_plural'),
    subtitle: name,
    data: data,
    cols: [t('property_asset_name'), t('property_opens')],
    onClose: function onClose() {
      return setHasModal(false);
    },
    moreLink: undefined
  }));
}
export default PopularAssetInFolderOrPlaylistStats;